export const appArrowUpIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.492 16.137L12.137 11.0229L6.78196 16.1369L5.13696 14.5625L12.137 7.86285L19.137 14.5625L17.492 16.137Z" fill="#4F4F4F"/></svg>`,
    name: 'arrow-up'
};